import React from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { defaultAuthToastContainerProps } from "../../config/reactToastifyDefaults";
import { useFormik } from "formik";

import { Button, Input } from "../../components/ui";
import AuthHeroPanel from "../../components/auth/AuthHeroPanel";
import { resetPassword } from "../../utils";
import { resetPasswordSchema } from "../../validators/authValidators";

export default function AuthResetPasswordPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = (searchParams.get("token") || "").trim();
  const emailFromQuery = (searchParams.get("email") || "").trim();

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: emailFromQuery,
      password: "",
      confirmPassword: "",
    },
    validationSchema: resetPasswordSchema,
    onSubmit: async (values) => {
      if (!token) {
        toast.error("Reset token is missing.");
        return;
      }
      try {
        const result = await resetPassword(values.email, token, values.password);
        if (result?.success) {
          toast.success(result?.msg || "Password reset successful");
          setTimeout(() => navigate("/login"), 800);
        } else {
          toast.error(result?.error || result?.msg || "Password reset failed");
        }
      } catch (error) {
        toast.error("Password reset failed");
      }
    },
  });

  return (
    <section className="lg:flex min-h-screen">
      <div className="bg-white w-full lg:w-[38%] flex items-center justify-center px-5 sm:px-8 xl:px-12 py-8">
        <div className="w-full">
          <img src="/new-logo/logo.png" alt="Innlead" className="h-12 w-auto" />

          <h2 className="mt-8 text-h4 font-semibold text-black">Reset Your Password</h2>
          <p className="mt-2 text-sm text-black/60">Set a new password for your account</p>

          <form onSubmit={formik.handleSubmit} className="mt-8 flex flex-col gap-5">
            <Input
              label="Your Email address *"
              id="reset-email"
              name="email"
              value={formik.values.email}
              readOnly
              className="bg-primary/60"
              error={formik.touched.email ? formik.errors.email : ""}
            />

            <Input
              label="New Password"
              id="reset-password"
              type="password"
              placeholder="Enter new password"
              name="password"
              value={formik.values.password}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.password ? formik.errors.password : ""}
            />

            <Input
              label="Confirm Password"
              id="reset-confirm-password"
              type="password"
              placeholder="Confirm new password"
              name="confirmPassword"
              value={formik.values.confirmPassword}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.confirmPassword ? formik.errors.confirmPassword : ""}
            />

            <Button variant="primary" fullWidth size="lg" type="submit" disabled={formik.isSubmitting}>
              Reset Password
            </Button>
          </form>

          <p className="mt-4 text-sm text-black/60">
            Return to{" "}
            <Link to="/login" className="text-brand-blue font-medium underline">
              Sign in
            </Link>
          </p>

          <ToastContainer {...defaultAuthToastContainerProps} />
        </div>
      </div>

      <AuthHeroPanel />
    </section>
  );
}

